import React from 'react';
import { Check, X } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Audience() {
  const forYou = ['High-achieving women who feel "on edge" from Sunday afternoon onwards.', 'Corporate or creative professionals dealing with chronic burnout.', 'People-pleasers who dread the start-of-week demands from colleagues.', 'Anyone who feels like their weekend is just a "countdown" to stress.'];
  const notForYou = ['People looking for a 50-step "That Girl" aesthetic routine.', 'Anyone who wants a complex 5-year life planning system.', 'Those unwilling to spend 20 minutes on a Sunday to save their sanity on Monday.'];
  return <section className="bg-cream py-20 md:py-28 px-6" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16" data-id="element-15">
          <FadeIn data-id="element-16">
            <div data-id="element-17">
              <h3 className="text-2xl font-serif text-forest mb-8 border-b border-sage/30 pb-4" data-id="element-18">
                This is for you if...
              </h3>
              <ul className="space-y-6" data-id="element-19">
                {forYou.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-20">
                    <div className="mt-1 bg-sage/20 p-1 rounded-full flex-shrink-0" data-id="element-21">
                      <Check className="w-4 h-4 text-forest" strokeWidth={3} data-id="element-22" />
                    </div>
                    <span className="text-charcoal/90 font-light" data-id="element-23">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-24">
            <div data-id="element-25">
              <h3 className="text-2xl font-serif text-charcoal/50 mb-8 border-b border-charcoal/10 pb-4" data-id="element-26">
                This is NOT for you if...
              </h3>
              <ul className="space-y-6" data-id="element-27">
                {notForYou.map((item, i) => <li key={i} className="flex items-start gap-4 opacity-70" data-id="element-28">
                    <div className="mt-1 p-1 flex-shrink-0" data-id="element-29">
                      <X className="w-4 h-4 text-charcoal/40" strokeWidth={2} data-id="element-30" />
                    </div>
                    <span className="text-charcoal/80 font-light" data-id="element-31">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}